export const OT01_BIKE_ID = 29;
export const XXTI_2026_BIKE_ID = 32;

const DEFAULT_COMPONENT_CATEGORY_ORDER = [
  "25",
  "4",
  "5",
  "6",
  "8",
  "9",
  "11",
  "10",
  "14",
  "7",
  "12",
  "27",
];

const COMPONENT_CATEGORY_ORDER_WITH_FORK = [
  ...DEFAULT_COMPONENT_CATEGORY_ORDER,
  "23",
];

export function supportsSecondaryColor(bikeId) {
  return ![20, 23, XXTI_2026_BIKE_ID].includes(Number(bikeId));
}

export function componentCategoryOrder(bikeId) {
  const id = Number(bikeId);

  if (id === 17) {
    return ["25", "4", "5", "6", "8", "9", "11", "10", "14", "7", "23"];
  }

  if ([18, 23, 24, XXTI_2026_BIKE_ID].includes(id)) {
    return [...COMPONENT_CATEGORY_ORDER_WITH_FORK];
  }

  return [...DEFAULT_COMPONENT_CATEGORY_ORDER];
}

export function usesPrimaryColorForBottleCages(bikeId, componentId) {
  return Number(bikeId) === XXTI_2026_BIKE_ID && Number(componentId) === 41;
}

export function isBrushedColorName(colorName) {
  return String(colorName || "").toLowerCase().includes("brushed");
}

export function sortBrushedColorsFirst(colors) {
  if (!Array.isArray(colors)) {
    return [];
  }

  const brushed = [];
  const standard = [];

  colors.forEach((color) => {
    if (!color) {
      return;
    }

    if (isBrushedColorName(color.name)) {
      brushed.push(color);
    } else {
      standard.push(color);
    }
  });

  return [...brushed, ...standard];
}

export function isOt01BrushedColor(bikeId, colorName) {
  return Number(bikeId) === OT01_BIKE_ID && isBrushedColorName(colorName);
}
